import { SVButton, SVLoader } from '@/components/core';
import ExternalAccountForm from '@/components/externalAccounts/form/ExternalAccountForm';
import DefaultLayout from '@/components/layouts/DefaultLayout';
import { initialExternalAccountForm } from '@/constants/externalAccounts';
import { ROUTES } from '@/constants/routes';
import { useGetCustomerDetails } from '@/hooks/requests/useCustomers';
import { createFullName } from '@/utils/string';
import { Card, Typography } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';

export default function CustomersExternalAccountsAddPage() {
  const { uuid = '' } = useParams();
  const navigate = useNavigate();
  const { customerDetails, isCustomerDetailsPending } =
    useGetCustomerDetails(uuid);

  if (isCustomerDetailsPending) {
    return (
      <DefaultLayout header="">
        <Card>
          <SVLoader />
        </Card>
      </DefaultLayout>
    );
  }

  if (!customerDetails) {
    return (
      <DefaultLayout header="">
        <Card>
          <Typography>
            Something went wrong retreiving the customer. Our team has been
            notified.
          </Typography>
        </Card>
      </DefaultLayout>
    );
  }

  const customerName = createFullName(
    customerDetails.firstName,
    customerDetails.lastName,
  );

  return (
    <DefaultLayout
      header="External Accounts"
      buttons={[
        <SVButton
          key="add"
          onClick={() =>
            navigate(`${ROUTES.EXTERNAL_ACCOUNTS_ADD}?customerId=${uuid}`)
          }>
          Add
        </SVButton>,
      ]}
      breadcrumb={[
        {
          label: 'Customers',
          href: ROUTES.CUSTOMERS,
        },
        {
          label: customerName,
          href: `${ROUTES.CUSTOMERS}/${customerDetails.uuid}`,
        },
        {
          label: 'External Accounts',
          isActive: true,
        },
      ]}>
      <ExternalAccountForm
        defaultValues={{
          ...initialExternalAccountForm,
          companyId: customerDetails.company.uuid,
          customerId: uuid,
        }}
        onLeave={() => navigate(ROUTES.EXTERNAL_ACCOUNTS)}
        onSuccess={(uuid: string) =>
          navigate(`${ROUTES.EXTERNAL_ACCOUNTS}/${uuid}`)
        }
      />
    </DefaultLayout>
  );
}
